import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "", enum: "NORMAL" },
  { value: 2, text: "完売", enum: "SOLDOUT" },
  { value: 3, text: "減数", enum: "SUBTRACTION" },
  { value: 4, text: "分納", enum: "INSTALLMENT" },
]);
